/* Art Scout collector features: Saved works, Follow the artist,
   notify me of similar works, commission requests. */
(function () {
  if (window.cfCollector) return;

  var KEY_SAVED = 'cf_saved', KEY_PROFILE = 'cf_profile', KEY_FOLLOW = 'cf_follow', KEY_NOTE = 'cf_note_dismissed';

  /* ---------- storage (works without it, just forgets on reload) ---------- */
  var mem = {};
  function load(k, d) {
    try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return mem[k] || d; }
  }
  function store(k, v) {
    mem[k] = v;
    try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
  }

  var saved = load(KEY_SAVED, []);
  var follows = load(KEY_FOLLOW, []);
  function profile() { return load(KEY_PROFILE, null); }

  function slug(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- sending: Shopify's own forms, posted into a hidden frame ----------
     Real <form> posts keep Shopify's spam protection working. type is
     'customer' (saves the person with tags) or 'contact' (emails the store). */
  /* one submission at a time: two forms bound to the spam check at once can drop one */
  var queue = Promise.resolve();
  function send(type, fields) {
    queue = queue.then(function () {
      sendNow(type, fields);
      return new Promise(function (r) { setTimeout(r, 2500); });
    });
    return Promise.resolve();
  }

  var seq = 0;
  function sendNow(type, fields) {
    var name = 'cf-sink-' + (++seq);
    var frame = document.createElement('iframe');
    frame.name = name;
    frame.title = 'Form submission';
    frame.setAttribute('aria-hidden', 'true');
    frame.tabIndex = -1;
    frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
    document.body.appendChild(frame);

    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/contact#cf-' + type;
    form.acceptCharset = 'UTF-8';
    form.target = name;
    form.hidden = true;
    var all = Object.assign({ form_type: type, utf8: '\u2713' }, fields);
    Object.keys(all).forEach(function (k) {
      if (all[k] == null || all[k] === '') return;
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = k;
      i.value = all[k];
      form.appendChild(i);
    });
    document.body.appendChild(form);

    function go() { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
    /* Shopify's spam protection only lets a form through once it is bound to it */
    var cap = window.Shopify && window.Shopify.captcha;
    if (cap && typeof cap.protect === 'function') {
      try { cap.protect(form, go); } catch (e) { go(); }
    } else {
      go();
    }
    setTimeout(function () { frame.remove(); form.remove(); }, 60000);
    /* the visitor never waits on this: thank-you states show right away */
    return Promise.resolve();
  }

  function saveCustomer(p, tags) {
    return send('customer', {
      'contact[email]': p.email,
      'contact[first_name]': p.name,
      'contact[tags]': ['collector'].concat(tags).filter(Boolean).join(', ')
    });
  }
  function emailStore(p, fields) {
    var f = { 'contact[name]': p.name, 'contact[email]': p.email };
    Object.keys(fields).forEach(function (k) { f['contact[' + k + ']'] = fields[k]; });
    return send('contact', f);
  }

  /* ---------- forms: shared validation ---------- */
  function readForm(form) {
    var email = form.querySelector('[name="email"]');
    var name = form.querySelector('[name="name"]');
    var p = profile() || {};
    var v = { email: (email && email.value.trim()) || p.email || '', name: (name && name.value.trim()) || p.name || '' };
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.email)) {
      email.setAttribute('aria-invalid', 'true');
      email.focus();
      return null;
    }
    if (email) email.removeAttribute('aria-invalid');
    store(KEY_PROFILE, v);
    return v;
  }
  function prefill(scope) {
    var p = profile();
    if (!p) return;
    (scope || document).querySelectorAll('.cf-form').forEach(function (f) {
      var e = f.querySelector('[name="email"]'), n = f.querySelector('[name="name"]');
      if (e && !e.value) e.value = p.email || '';
      if (n && !n.value) n.value = p.name || '';
    });
  }
  function busy(form, on) {
    var b = form.querySelector('[type="submit"]');
    if (b) { b.disabled = on; b.classList.toggle('is-busy', on); }
  }

  /* ---------- Saved works ---------- */
  function isSaved(h) { return saved.some(function (s) { return s.handle === h; }); }

  function itemFrom(btn) {
    var d = btn.dataset;
    return { handle: d.handle, title: d.title, artist: d.artist, artistHandle: d.artistHandle, img: d.img, price: d.price, dims: d.dims, style: d.style, sold: d.sold === '1', at: Date.now() };
  }

  function savedTags() {
    var t = ['saved-works'];
    saved.slice(-12).forEach(function (s) {
      t.push('saved-' + s.handle);
      if (s.artistHandle) t.push('saved-artist-' + s.artistHandle);
    });
    return t.filter(function (x, i) { return t.indexOf(x) === i; });
  }
  function savedSummary() {
    return saved.map(function (s) {
      return '- ' + s.title + (s.artist ? ' (' + s.artist + ')' : '') + (s.price ? ', ' + s.price : '') + (s.sold ? ', sold' : '') + '\n  ' + location.origin + '/products/' + s.handle;
    }).join('\n');
  }

  function syncHearts() {
    document.querySelectorAll('[data-cf-save]').forEach(function (b) {
      var on = isSaved(b.dataset.handle);
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + (b.dataset.title || 'artwork'));
      var lbl = b.querySelector('.cf-heart__label');
      if (lbl) lbl.textContent = on ? 'Saved' : 'Save';
    });
    var n = saved.length;
    document.querySelectorAll('[data-cf-count]').forEach(function (c) {
      c.textContent = n;
      c.hidden = !n;
    });
    document.querySelectorAll('[data-cf-count-text]').forEach(function (c) { c.textContent = n ? '(' + n + ')' : ''; });
  }

  function toggleSave(btn) {
    var h = btn.dataset.handle;
    if (!h) return;
    if (isSaved(h)) {
      saved = saved.filter(function (s) { return s.handle !== h; });
    } else {
      saved.push(itemFrom(btn));
      btn.classList.remove('is-pop');
      void btn.offsetWidth;
      btn.classList.add('is-pop');
      var p = profile();
      if (p && p.email && p.kept) {
        saveCustomer(p, savedTags());
      } else if (saved.length >= 2) {
        maybeNote();
      }
    }
    store(KEY_SAVED, saved);
    syncHearts();
    renderDrawer();
  }

  /* ---------- drawer ---------- */
  var drawer, lastFocus;
  function renderDrawer() {
    drawer = drawer || document.getElementById('cf-drawer');
    if (!drawer) return;
    var list = drawer.querySelector('[data-cf-list]');
    var html = '';
    saved.slice().reverse().forEach(function (s) {
      var meta = [s.dims, s.sold ? 'Sold' : s.price].filter(Boolean).join(' · ');
      html += '<li class="cf-item">' +
        '<a class="cf-item__img" href="/products/' + esc(s.handle) + '">' + (s.img ? '<img src="' + esc(s.img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="cf-item__info">' +
          '<a class="cf-item__artist" href="/products/' + esc(s.handle) + '">' + esc(s.artist || s.title) + '</a>' +
          (s.artist ? '<span class="cf-item__title">' + esc(s.title) + '</span>' : '') +
          '<span class="cf-item__meta">' + esc(meta) + '</span>' +
        '</div>' +
        '<button type="button" class="cf-item__remove" data-cf-remove="' + esc(s.handle) + '" aria-label="Remove ' + esc(s.title) + '">Remove</button>' +
      '</li>';
    });
    list.innerHTML = html;
    drawer.querySelector('[data-cf-empty]').hidden = saved.length > 0;
    var p = profile();
    var kept = !!(p && p.email && p.kept);
    drawer.querySelector('[data-cf-foot]').hidden = saved.length === 0;
    drawer.querySelector('[data-cf-keep]').hidden = kept;
    drawer.querySelector('[data-cf-enquire]').hidden = !kept;
    if (kept) drawer.querySelector('[data-cf-kept-as]').textContent = 'We\'ll keep you posted at ' + p.email + '.';
  }

  function openLayer(el) {
    lastFocus = document.activeElement;
    el.hidden = false;
    document.documentElement.classList.add('cf-locked');
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    var focusEl = el.querySelector('[tabindex="-1"]') || el;
    setTimeout(function () { focusEl.focus({ preventScroll: true }); }, 50);
  }
  function closeLayer(el) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('cf-locked');
    setTimeout(function () { el.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function openDrawer() {
    renderDrawer();
    prefill(drawer);
    closeNote();
    openLayer(drawer);
  }

  /* ---------- "Keep your selection" note ---------- */
  function maybeNote() {
    var note = document.getElementById('cf-note');
    if (!note || !note.hidden) return;
    var t = load(KEY_NOTE, 0);
    if (t && Date.now() - t < 1000 * 60 * 60 * 24 * 7) return;
    if (drawer && !drawer.hidden) return;
    prefill(note);
    note.hidden = false;
    requestAnimationFrame(function () { note.classList.add('is-open'); });
  }
  function closeNote(dismissed) {
    var note = document.getElementById('cf-note');
    if (!note || note.hidden) return;
    if (dismissed) store(KEY_NOTE, Date.now());
    note.classList.remove('is-open');
    setTimeout(function () { note.hidden = true; }, 320);
  }

  function submitKeep(form) {
    var p = readForm(form);
    if (!p) return;
    busy(form, true);
    p.kept = true;
    store(KEY_PROFILE, p);
    Promise.all([
      emailStore(p, {
        Request: 'Saved a selection of works',
        body: (p.name || 'A collector') + ' saved these works:\n\n' + savedSummary()
      }),
      saveCustomer(p, savedTags())
    ]).then(function () {
      busy(form, false);
      closeNote();
      renderDrawer();
      toast('Thank you');
    });
  }

  function submitEnquire(btn) {
    var p = profile();
    if (!p || !p.email) return;
    btn.disabled = true;
    emailStore(p, {
      Request: 'Enquiry about saved works',
      body: (p.name || 'A collector') + ' would like to know more about these works:\n\n' + savedSummary()
    }).then(function () {
      btn.hidden = true;
      drawer.querySelector('[data-cf-enquire-done]').hidden = false;
    });
  }

  /* ---------- Follow the artist ---------- */
  var pendingFollow = null;
  function isFollowing(h) { return follows.indexOf(h) > -1; }
  function syncFollows() {
    document.querySelectorAll('[data-cf-follow]').forEach(function (b) {
      var on = isFollowing(b.dataset.cfFollow);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function setFollow(h, artist, p) {
    if (!isFollowing(h)) follows.push(h);
    store(KEY_FOLLOW, follows);
    syncFollows();
    return saveCustomer(p, ['follow-' + h]);
  }
  function clickFollow(btn) {
    var h = btn.dataset.cfFollow, artist = btn.dataset.artist;
    if (isFollowing(h)) {
      follows = follows.filter(function (x) { return x !== h; });
      store(KEY_FOLLOW, follows);
      syncFollows();
      toast('You no longer follow ' + artist);
      return;
    }
    var p = profile();
    if (p && p.email) {
      setFollow(h, artist, p);
      toast('Following ' + artist);
      return;
    }
    pendingFollow = { handle: h, artist: artist };
    var m = document.getElementById('cf-follow');
    m.querySelectorAll('[data-cf-artist-name]').forEach(function (n) { n.textContent = artist; });
    m.querySelector('[data-cf-step="ask"]').hidden = false;
    m.querySelector('[data-cf-step="done"]').hidden = true;
    prefill(m);
    openLayer(m);
  }
  function submitFollow(form) {
    var p = readForm(form);
    if (!p || !pendingFollow) return;
    busy(form, true);
    setFollow(pendingFollow.handle, pendingFollow.artist, p).then(function () {
      busy(form, false);
      var m = document.getElementById('cf-follow');
      m.querySelector('[data-cf-step="ask"]').hidden = true;
      m.querySelector('[data-cf-step="done"]').hidden = false;
    });
  }

  /* ---------- Sold piece: notify me of similar works ---------- */
  function submitSimilar(form) {
    var box = form.closest('.cf-sold');
    var p = readForm(form);
    if (!p || !box) return;
    var d = box.dataset;
    busy(form, true);
    var tags = ['similar-request', 'similar-' + d.handle];
    if (d.artistHandle) tags.push('similar-' + d.artistHandle, 'follow-' + d.artistHandle);
    (d.style || '').split('|').filter(Boolean).forEach(function (s) { tags.push('style-' + slug(s)); });
    if (d.band) tags.push('price-' + d.band);
    if (d.artistHandle && !isFollowing(d.artistHandle)) { follows.push(d.artistHandle); store(KEY_FOLLOW, follows); syncFollows(); }
    Promise.all([
      emailStore(p, {
        Request: 'Lead: wants works similar to a sold piece',
        Artwork: d.title + ' (sold)',
        Artist: d.artist,
        Style: (d.style || '').split('|').join(', '),
        Price: d.price,
        Link: location.origin + '/products/' + d.handle
      }),
      saveCustomer(p, tags)
    ]).then(function () {
      busy(form, false);
      box.querySelector('[data-cf-step="ask"]').hidden = true;
      var done = box.querySelector('[data-cf-step="done"]');
      done.hidden = false;
      done.setAttribute('tabindex', '-1');
      done.focus({ preventScroll: true });
    });
  }

  /* ---------- Commission request (commission page) ---------- */
  function submitCommission(form) {
    var p = readForm(form);
    if (!p) return;
    var get = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ''; };
    busy(form, true);
    var ref = form.dataset.ref || '', artist = get('artist') || form.dataset.artist || '';
    var jobs = [emailStore(p, {
      Request: 'Commission request',
      'Inspired by': ref ? (form.dataset.refTitle || ref) + ' (' + location.origin + '/products/' + ref + ')' : '',
      Artist: artist,
      Phone: get('phone'),
      Size: get('size'),
      'Colors or mood': get('mood'),
      Budget: get('budget'),
      Timeline: get('timeline'),
      body: get('notes')
    })];
    var consent = form.querySelector('[name="consent"]');
    if (!consent || consent.checked) {
      var tags = ['commission-interest'];
      if (artist) tags.push('commission-' + slug(artist));
      if (ref) tags.push('commission-ref-' + ref);
      jobs.push(saveCustomer(p, tags));
    }
    Promise.all(jobs).then(function () {
      busy(form, false);
      var wrap = form.closest('[data-cf-commission]');
      wrap.querySelector('[data-cf-step="ask"]').hidden = true;
      var done = wrap.querySelector('[data-cf-step="done"]');
      done.hidden = false;
      done.setAttribute('tabindex', '-1');
      done.focus({ preventScroll: true });
      window.scrollTo({ top: wrap.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' });
    });
  }

  /* ---------- toast ---------- */
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cf-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-open');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-open'); }, 2600);
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var heart = t.closest('[data-cf-save]');
    if (heart) { e.preventDefault(); e.stopPropagation(); toggleSave(heart); return; }
    if (t.closest('[data-cf-open-saved]')) { e.preventDefault(); openDrawer(); return; }
    var rm = t.closest('[data-cf-remove]');
    if (rm) {
      saved = saved.filter(function (s) { return s.handle !== rm.dataset.cfRemove; });
      store(KEY_SAVED, saved);
      syncHearts();
      renderDrawer();
      return;
    }
    var fb = t.closest('[data-cf-follow]');
    if (fb) { e.preventDefault(); clickFollow(fb); return; }
    if (t.closest('[data-cf-note-close]')) { closeNote(true); return; }
    if (t.closest('[data-cf-enquire-btn]')) { submitEnquire(t.closest('[data-cf-enquire-btn]')); return; }
    if (t.closest('#cf-sold-sticky')) {
      var sold = document.getElementById('cf-sold');
      if (sold) {
        sold.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var em = sold.querySelector('[name="email"]');
        if (em) setTimeout(function () { em.focus({ preventScroll: true }); }, 500);
      }
      return;
    }
    var close = t.closest('[data-cf-close]');
    if (close) closeLayer(close.closest('.cf-drawer, .cf-modal'));
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cf-form]');
    if (!form) return;
    e.preventDefault();
    var kind = form.dataset.cfForm;
    if (kind === 'keep') submitKeep(form);
    else if (kind === 'follow') submitFollow(form);
    else if (kind === 'similar') submitSimilar(form);
    else if (kind === 'commission') submitCommission(form);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.cf-drawer:not([hidden]), .cf-modal:not([hidden])').forEach(closeLayer);
    closeNote(true);
  });

  /* keep other tabs in step */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY_SAVED) { saved = load(KEY_SAVED, []); syncHearts(); renderDrawer(); }
    if (e.key === KEY_FOLLOW) { follows = load(KEY_FOLLOW, []); syncFollows(); }
  });

  /* put each card heart in the top right corner of the artwork's grey square */
  function placeHearts() {
    var inset = window.innerWidth < 768 ? 8 : 10;
    document.querySelectorAll('.cf-heart').forEach(function (h) {
      if (h.closest('.cf-pdp')) return;
      var host = h.parentElement;
      var t = host.querySelector('.art-card') || host.querySelector('img');
      if (!t) return;
      var hr = host.getBoundingClientRect(), tr = t.getBoundingClientRect();
      if (!hr.width || !tr.width) return;
      h.style.top = Math.max(0, Math.round(tr.top - hr.top + inset)) + 'px';
      h.style.right = Math.max(0, Math.round(hr.right - tr.right + inset)) + 'px';
    });
  }
  var placeT;
  function placeSoon() { clearTimeout(placeT); placeT = setTimeout(placeHearts, 120); }

  function init() {
    placeHearts();
    window.addEventListener('load', placeHearts);
    window.addEventListener('resize', placeSoon);
    document.addEventListener('click', placeSoon);
    document.addEventListener('load', function (e) { if (e.target.tagName === 'IMG') placeSoon(); }, true);
    syncHearts();
    syncFollows();
    prefill();
    /* sold flags can change after a save (a piece sells): refresh from the page */
    document.querySelectorAll('[data-cf-save]').forEach(function (b) {
      var s = saved.filter(function (x) { return x.handle === b.dataset.handle; })[0];
      if (s && s.sold !== (b.dataset.sold === '1')) { s.sold = b.dataset.sold === '1'; store(KEY_SAVED, saved); }
    });
    /* cards added later (carousels, filters) */
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; syncHearts(); syncFollows(); placeHearts(); }, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.cfCollector = { open: openDrawer, toast: toast };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
